export const IP_CONFIG_API_KEY = "3d0179c8b031d3";

// Firebase Configurations
export const FB_API_KEY = "AIzaSyB7i0yPkxrBhicmdDW42RxO1-wNDGYlWF8";
export const FB_AUTH_DOMAIN = "wisedoctor-44d8e.firebaseapp.com";
export const FB_PROJECT_ID = "wisedoctor-44d8e";
export const FB_STORAGE_BUCKET = "wisedoctor-44d8e.appspot.com";
export const FB_MSG_SENDER_ID = "119598654790";
export const FB_APP_ID = "1:119598654790:web:eb79492579b9e106437147";
export const FB_MEASUREMENT_ID = "G-QX5WZZFRX2";